import React from 'react';
import Tooltip from '@src/components/Tooltip';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormatQuoteRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';

const OpenClientPause = ({
  isMoreButton,
  handleOpenClientPause,
  hasClientPause,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`group group-open-client-pause ${
        isMoreButton && 'group-open-client-pause-more-button'
      }`}
    >
      <Tooltip arrow title={t('pauseSettings')} placement="top">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button
            className="custom-button margin-right"
            onClick={handleOpenClientPause}
            disabled={!hasClientPause}
            color="iconPrimary"
            data-id="open-punct-duration"
          >
            <FormatQuoteRounded
              sx={{
                fontSize: 24,
                color: hasClientPause ? COLOR.navyBlue : COLOR.colorGrayV2,
              }}
            />
          </Button>
        </div>
      </Tooltip>
    </div>
  );
};

export default OpenClientPause;
